var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophyOutline16Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00003 14.5H11H6.00003ZM8.50003 14.5V10.5V14.5ZM12.5 7C12.5 5.4175 12.4975 2.79281 12.4963 2C12.4963 1.86739 12.4436 1.74021 12.3498 1.64645C12.2561 1.55268 12.1289 1.5 11.9963 1.5L5.00284 1.50812C4.8705 1.50812 4.74356 1.56059 4.64984 1.65402C4.55612 1.74745 4.50326 1.87423 4.50284 2.00656C4.50284 2.96219 4.49878 6.04312 4.49878 7C4.49878 9.00875 7.09253 10.5 8.49878 10.5C9.90503 10.5 12.5 9.00875 12.5 7Z",
    stroke: "#126C46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3H15V3.5C15 5.22563 13.9516 7 12.5 7M4.5 3H2V3.5C2 5.22563 3.04844 7 4.5 7V3Z",
    stroke: "#126C46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyOutline16Px);
export default __webpack_public_path__ + "static/media/trophy-outline-16px.188828598ab2babc3848025800d72855.svg";
export { ForwardRef as ReactComponent };